import React, { useState, useMemo } from 'react';
import { Search, ChevronDown, ChevronRight } from 'lucide-react';
import './HelpPage.scss';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQCategory {
  title: string;
  items: FAQItem[];
}

const faqData: FAQCategory[] = [
  {
    title: 'Skelbimų paieška',
    items: [
      { question: 'Greita skelbimų paieška', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.\n\nCum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio.' },
      { question: 'Detali skelbimų paieška', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Skelbimų paieška pagal sritį', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Skelbimų paieška pagal vietą', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Skelbimų paieška pagal pareigybes', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Skelbimų paieška pagal įmonę', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Paieškos tikslinimas', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip išsaugoti skelbimus?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip išsaugoti skelbimų paiešką?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip paleisti išsaugotą skelbimų paiešką?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip keisti išsaugotos paieškos nustatymus?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip esamos paieškos pagrindu sukurti naują paiešką?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip ištrinti išsaugotą skelbimų paiešką', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
    ]
  },
  {
    title: 'Kandidatavimas pagal darbo skelbimus',
    items: [
      { question: 'Kaip kandidatuoti registruotam vartotojui?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus. Integer commodo neque et urna sodales.' },
      { question: 'Kaip kandidatuoti neregistruotam vartotojui?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip kandidatuoti į kelias pozicijas iš karto?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip galima matyti skelbimus, į kuriuos jau kandidatuota?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
    ]
  },
  {
    title: 'Kaip įvesti CV?',
    items: [
      { question: 'Kaip kandidatuoti registruotam vartotojui?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip kandidatuoti neregistruotam vartotojui?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip kandidatuoti į kelias pozicijas iš karto?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip galima matyti skelbimus, į kuriuos jau kandidatuota?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
    ]
  },
  {
    title: 'Motyvaciniai laiškai',
    items: [
      { question: 'Kaip sukurti ir išsaugoti motyvacinį laišką?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip redaguoti motyvacinį laišką?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip sukurti naują motyvacinį laišką jau esančio motyvacinio laiško pagrindu?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip pašalinti motyvacinį laišką?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
    ]
  },
  {
    title: 'Kreipimosi laiškai',
    items: [
      { question: 'Kaip sukurti ir išsaugoti kreipimosi laišką?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip redaguoti kreipimosi laišką?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip sukurti naują kreipimosi laišką jau esančio kreipimosi laiško pagrindu?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip pašalinti kreipimosi laišką?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
    ]
  },
  {
    title: 'Skelbimų tvarkymas pagal sukurtas taisykles',
    items: [
      { question: 'Taisyklių esmė ir jų teikiami privalumai', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Taisyklių tipai pagal atliekamą funkciją', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip sukurti naują taisyklę?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip keisti taisyklės kriterijus?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip sukurti naują taisyklę jau esančios taisyklės pagrindu?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip sustabdyti taisyklės veikimą?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip ištrinti taisyklę?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
    ]
  },
  {
    title: 'Skelbimų kategorijų tvarkymas',
    items: [
      { question: 'Kaip sukurti naują skelbimų kategoriją?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip keisti skelbimų kategorijos nustatymus?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip sukurti naują skelbimų kategoriją jau esančios kategorijos pagrindu?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip ištrinti skelbimų kategoriją?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
    ]
  },
  {
    title: 'Auksinė narystė',
    items: [
      { question: 'Kokie yra auksinės narystės privalumai?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip įsigyti auksinę narystę?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip atsisakyti auksinės narystės?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
    ]
  },
  {
    title: 'Skelbimų tvarkymas asmeninėje paskyroje',
    items: [
      { question: 'Gautų skelbimų aplankas', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Atsakytų skelbimų aplankas', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Išsaugotų skelbimų aplankas', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Ištrintų skelbimų aplankas', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip perkelti skelbimus iš vieno aplanko į kitą?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip persijusti skelbimus?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip ištrinti skelbimus?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
    ]
  },
  {
    title: 'Skelbimų prenumerata',
    items: [
      { question: 'Kaip sukurti skelbimų prenumeratą?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip keisti skelbimų prenumeratos nustatymus?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip sukurti naują skelbimų prenumeratą jau esančios prenumeratos pagrindu?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip sustabdyti skelbimų prenumeratą?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
      { question: 'Kaip ištrinti skelbimų prenumeratą?', answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porta rhoncus purus sit amet maximus.' },
    ]
  },
];

const HelpPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedCategories, setExpandedCategories] = useState<string[]>([faqData[0]?.title || '']);
  const [expandedQuestions, setExpandedQuestions] = useState<string[]>(['Greita skelbimų paieška']);
  const [showDropdown, setShowDropdown] = useState(false);

  // Search results for autocomplete
  const searchResults = useMemo(() => {
    if (!searchQuery.trim()) return [];
    
    const query = searchQuery.toLowerCase();
    const results: { category: string; question: string; answer: string }[] = [];
    
    faqData.forEach(category => {
      category.items.forEach(item => {
        if (item.question.toLowerCase().includes(query) || item.answer.toLowerCase().includes(query)) {
          results.push({
            category: category.title,
            question: item.question,
            answer: item.answer
          });
        }
      });
    });
    
    return results.slice(0, 5);
  }, [searchQuery]);

  const toggleCategory = (title: string) => {
    setExpandedCategories(prev => 
      prev.includes(title) 
        ? prev.filter(t => t !== title)
        : [...prev, title]
    );
  };

  const toggleQuestion = (question: string) => {
    setExpandedQuestions(prev => 
      prev.includes(question)
        ? prev.filter(q => q !== question)
        : [...prev, question]
    );
  };

  const handleSearch = () => {
    setShowDropdown(false);
    // Could scroll to first result or filter FAQ
  };

  const handleSelectResult = (result: { category: string; question: string }) => {
    setSearchQuery('');
    setShowDropdown(false);
    
    // Expand the category and question
    if (!expandedCategories.includes(result.category)) {
      setExpandedCategories(prev => [...prev, result.category]);
    }
    if (!expandedQuestions.includes(result.question)) {
      setExpandedQuestions(prev => [...prev, result.question]);
    }

    // Scroll to the question
    setTimeout(() => {
      const element = document.getElementById(`question-${result.question.replace(/\s+/g, '-')}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  const highlightText = (text: string, query: string) => {
    if (!query.trim()) return text;
    
    const regex = new RegExp(`(${query})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, i) => 
      regex.test(part) ? <strong key={i}>{part}</strong> : part
    );
  };

  return (
    <div className="help-page">
      {/* Hero Section */}
      <section className="help-hero">
        <div className="hero-content">
          <h1>Pagalba</h1>
          <div className="search-container">
            <div className="search-wrapper">
              <input
                type="text"
                placeholder="Įveskite paieškos žodį"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setShowDropdown(true);
                }}
                onFocus={() => setShowDropdown(true)}
                onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
              />
              <button className="search-btn" onClick={handleSearch}>
                <Search size={18} />
                IEŠKOTI
              </button>
              
              {/* Search Dropdown */}
              {showDropdown && searchResults.length > 0 && (
                <div className="search-dropdown">
                  {searchResults.map((result, index) => (
                    <div 
                      key={index} 
                      className="dropdown-item"
                      onClick={() => handleSelectResult(result)}
                    >
                      <div className="item-question">
                        {highlightText(result.question, searchQuery)}
                      </div>
                      <div className="item-preview">
                        {highlightText(result.answer.substring(0, 150) + '...', searchQuery)}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="faq-container">
          {faqData.map((category) => (
            <div key={category.title} className="faq-category">
              <button 
                className={`category-header ${expandedCategories.includes(category.title) ? 'expanded' : ''}`}
                onClick={() => toggleCategory(category.title)}
              >
                <h2>{category.title}</h2>
                <ChevronDown size={20} className="chevron" />
              </button>
              
              {expandedCategories.includes(category.title) && (
                <div className="category-content">
                  {category.items.map((item) => (
                    <div 
                      key={item.question} 
                      className="faq-item"
                      id={`question-${item.question.replace(/\s+/g, '-')}`}
                    >
                      <button 
                        className={`question-header ${expandedQuestions.includes(item.question) ? 'expanded' : ''}`}
                        onClick={() => toggleQuestion(item.question)}
                      >
                        <ChevronRight size={16} className="chevron" />
                        <span>{item.question}</span>
                      </button>
                      
                      {expandedQuestions.includes(item.question) && (
                        <div className="answer">
                          {item.answer.split('\n\n').map((paragraph, i) => (
                            <p key={i}>{paragraph}</p>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default HelpPage;




